<template>
  <el-main class='main' style="height: calc(100vh - 56px - 20px)">
    <el-input v-model="name" placeholder="请输入名称" style="width: 200px;"></el-input>
    <el-button type="success" @click="query" icon="el-icon-search" style="float: right;background-color: #209323;">查询</el-button>
    <el-table
      :data='tableData'
      style="width: 100%; margin-top: 10px;">
      <el-table-column
        prop= 'cameraId'
        label= '监控id'
        width="80px">
      </el-table-column>
      <el-table-column
        prop= 'netPath'
        label= '图片'
        width="120px">
        <template slot-scope='scope'>
          <img :src="scope.row.netPath" v-if="scope.row.netPath!=null&&scope.row.netPath!=''" style="height: 50px;"/>
        </template>
      </el-table-column>
      <el-table-column
        prop= 'storePath'
        label= '存储位置'>
      </el-table-column>
      <el-table-column
        prop= 'name'
        label= '名称'>
      </el-table-column>
      <el-table-column
        prop= 'size'
        label= '大小'
        width="100px">
      </el-table-column>
      <el-table-column
        prop= 'cameraPosName'
        label= '相机预设点名'
        width="200px">
      </el-table-column>
      <el-table-column
        prop= 'addTime'
        label= '时间'
        width= '160'>
        <template slot-scope='scope'>
          {{ formatDateSimple(scope.row.addTime) }}
        </template>
      </el-table-column>
      <el-table-column
        fixed= 'right'
        label= '操作'
        width= '100'>
        <template slot-scope='scope'>
          <el-popover
            :ref="'delRef-'+scope.row.id"
            placement="right"
            width="160"
            trigger="click">
            <p>确定【编号:{{scope.row.id}}】删除吗？</p>
            <div style="text-align: right; margin: 0">
              <el-button size="mini" type="text" @click="delClose(scope.row)">取消</el-button>
              <el-button type="primary" size="mini" style="background-color: #209323;" @click="del(scope.row)">确定</el-button>
            </div>
            <el-button slot="reference" type='text' size='small' style="color: #f56c6c">删除</el-button>
          </el-popover>
        </template>
      </el-table-column>
    </el-table>
    <el-row style="text-align: right;margin-top: 20px;">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="current"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total">
      </el-pagination>
    </el-row>
  </el-main>
</template>
<script>
import requestService from '../../../util/request'
import { formatDate } from '../../../util/date'
export default {
  props: {
    cameraId: {
      type: Number,
      default: 0,
      required: false
    },
    cameraPosId: {
      type: Number,
      default: 0,
      required: false
    }
  },
  watch: {
    cameraId: {
      handler (newV, oldV) {
        this.form.cameraId = this.cameraId
        this.query()
      },
      immediate: true
    },
    cameraPosId: {
      handler (newV, oldV) {
        this.form.cameraPosId = this.cameraPosId
        this.query()
      },
      immediate: true
    }
  },  
  data () {
    return {
      tableData: [],
      name: '',
      formLabelWidth: '120px',
      current: 1,
      pageSize: 10,
      total: 0,
      pages: 0
    }
  },
  created () {
    this.query()
  },
  methods: {
    del (row) {
      let that = this
      document.body.click()
      let params = {
        id: row.id
      }
      requestService.post('/cameraPic/del', params, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        that.query()
      })
    },
    delClose (row) {
      document.body.click()
    },
    query () {
      let that = this
      requestService.get(`/cameraPic/listPage?current=${that.current}&pageSize=${that.pageSize}&cameraId=${that.cameraId}&cameraPosId=${that.cameraPosId}`, {
      }, {headers: {'Content-Type': 'application/x-www-form-urlencoded'}}).then((res) => {
        // console.log(res)
        that.tableData = res.data.body.records
        that.total = res.data.body.total
        that.pages = res.data.body.pages
      })
    },
    handleSizeChange (val) {
      this.pageSize = val
      this.query()
    },
    handleCurrentChange (val) {
      this.current = val
      this.query()
    },
    formatDateSimple (time) {
      var date = new Date(time)
      return formatDate(date, 'yyyy-MM-dd hh:mm:ss')
    }
  }
}
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/org-manage-components/cameraPic/Index.vue